import React from 'react';

function BipRow(props) {
  return (
    <div className="kupos-card bip-row" key={props.key}>
      <div className="card-and-card-details">
        <img src="/images/bip_card.svg" />
        <div className="bip-card-details font9">
          <div className="font10 bold-text bip-head">{props.t('PROFILE.CARD_NUMBER')}</div>
          <div className="font9">{props.val.card_number}</div>
        </div>
      </div>

      <div className="bip-item-border"></div>
      <div className="bip-card-details-middle">
        <div className="font10 bold-text bip-head">{props.t('PROFILE.NAME')}</div>
        <div className="font9 ">{props.val.card_name}</div>
      </div>
      <div className="bip-edit-delete-icons">
        <img onClick={() => props.showBipEditPopup(props.val)} src="/images/edit_profile.svg" />
        <img onClick={() => props.showBipDeletePopup(props.val)} src="/images/delete_card.svg" />
      </div>
    </div>
  );
}

export default BipRow;



// WEBPACK FOOTER //
// ./src/features/my-account/MainTabsBodyMyAccount/components/BipRow.js